import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import routes from '../../Config/routes';
import socialMedia from '../../Config/social-media';
import metadata from '../../metadata.json';
import packageInfo from '../../../package.json';
import './footer.css';
import ToggleNightMode from '../Toggle/ToggleNightMode';


const Footer = () => {

    const [showVersion] = useState(localStorage.getItem('showVersion'));
    const [rememberTheme, setRememberTheme] = useState(localStorage.rememberTheme === 'true');

    // Inspired by https://www.xovi.de/der-footer-meist-stiefmuetterlich-behandelt-und-stark-unterschaetzt/
    return (
        <footer className='relative w-full bg-ocean-blue-500 text-white font-sans flex flex-col items-center justify-center self-end'>
            {/* Waves */}
            <div className="waves">
                <div className="wave" id="wave1"></div>
                <div className="wave" id="wave2"></div>
                <div className="wave" id="wave3"></div>
                <div className="wave" id="wave4"></div>
                {/* <div className="absolute bg-[#015871] h-8 left-0 w-full -top-6"></div> */}
            </div>

            <div className="w-full bg-gradient-to-b from-[#015871] to-slate-800">
                <div className="grid sm:grid-cols-2 lg:grid-cols-none lg:grid-flow-col mx-auto w-max pt-5 pb-8 gap-10 sm:justify-center">

                    <div className="max-w-xs w-max">
                        <h3 className='text-2xl font-extralight mb-3'>Navigation</h3>
                        <ul className='flex flex-col font-light gap-1 text-sm'>
                            {routes.map(route => {
                                return (
                                    <li key={route.path}>
                                        <Link key={route.path} to={route.path} className='text-ocean-blue-200 hover:text-white'>{route.label}</Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    <div className="max-w-xs w-max">
                        <h3 className='text-2xl font-extralight mb-3'>Über mich</h3>
                        <p className='leading-relaxed font-light text-ocean-blue-200 text-sm'>
                            AIDA-Nicl.de ist eine Webseite über die Kreuzfahrtschiffe der Reederei AIDA Cruises. Dabei handelt es sich um ein privates Projekt, das unentgeltlich und in der Freizeit entwickelt und aktualisiert wird.
                        </p>
                        <Link to="/about" className='block font-medium mt-2 text-aida-yellow uppercase underline-offset-2 hover:decoration-white hover:underline'>
                            weiterlesen
                        </Link>
                    </div>

                    <div className="max-w-xs w-max">
                        <h3 className='text-2xl font-extralight mb-3'>Kontakt</h3>
                        <p className='leading-relaxed font-light text-ocean-blue-200 text-sm'>
                            Anregungen, Fragen und Kritik können jederzeit per Email an nicl@aida-nicl.de weitergegeben werden.
                        </p>
                        <ul className="flex flex-wrap gap-4 mt-3">
                            {socialMedia.map((el, idx) => {
                                return (
                                    <li key={idx} className={el.hoverColorClass}>
                                        <a href={el.path} rel='noreferrer' target='_blank'>
                                            {el.icon}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    <div className="max-w-xs w-max">
                        <h3 className='text-2xl font-light mb-3'>Ahoi! auf...</h3>
                        <img src={`${process.env.PUBLIC_URL}/assets/images/logo/logo-white.svg`} alt="Logo aida-nicl.de" className='h-20' />
                    </div>

                </div>

                <div className="flex items-center justify-center gap-4 p-8 text-center text-slate-400 text-sm font-light">
                    <div className="flex flex-col gap-0.5">
                        <p>Tag-Nacht-Wechsel</p>
                        <div className="text-xs flex gap-2 items-center justify-end">
                            <input type="checkbox" id="cb-remember-theme" className='rounded-full accent-aida-blue' checked={rememberTheme} onChange={e => {localStorage.rememberTheme = e.target.checked;setRememberTheme(!rememberTheme)}} />
                            <label htmlFor="cb-remember-theme">Einstellung merken</label>
                        </div>
                    </div>
                    <ToggleNightMode />
                    
                </div>

                <div className="p-8 text-center text-slate-400 text-xs font-light">
                    &copy; 2005-{new Date().getFullYear()} AIDA-Nicl.de
                    <span className='hidden sm:inline-block'>&nbsp;&middot;&nbsp;</span>
                    <span className='block sm:inline-block'>letzte Aktualisierung {metadata.buildDate}</span>
                    {showVersion && 
                        <p className='text-xs mt-8 italic'>Version {packageInfo.version}-{metadata.buildTag}.{metadata.buildNumber} &middot; {metadata.buildDate} {metadata.buildTime}</p>
                    }
                </div>
            </div>
        </footer>
    )
}

export default Footer
